export const linkToMyOS = (relativePath: string) => {
  return `${process.env.NEXT_PUBLIC_MYOPENSOOQ_BASE_DOMAIN}/${relativePath}?v=1`;
};
